var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgProductIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.054,
    height: 18.054,
    viewBox: "0 0 18.054 18.054",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.164,14.277H3.385a1.5,1.5,0,0,1-1.445-1.1L.03,6.206A.64.64,0,0,1,0,6,.753.753,0,0,1,.752,5.25h3.6L7.65.323A.738.738,0,0,1,8.274,0,.747.747,0,0,1,8.9.315l3.3,4.935h3.6A.753.753,0,0,1,16.549,6l-.022.2-1.911,6.973A1.517,1.517,0,0,1,13.164,14.277ZM1.737,6.755h0L3.392,12.78l9.771-.007,1.655-6.018H1.737ZM8.274,2.091,6.168,5.25h4.212Z",
    transform: "translate(0.753 1.52)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProductIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/product_icon.16d15028.svg";
export { ForwardRef as ReactComponent };